import CouponApi from '@apis/coupon/CouponApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetCouponsParams, GetDownloadableCouponsParams } from '@models/coupon';

const couponQueries = createQueryKeys('coupons', {
    list: (params: Omit<GetCouponsParams, 'page'>) => ({
        queryKey: ['list', params],
    }),
    detail: (id: string) => ({
        queryKey: ['detail', id],
        queryFn: () => CouponApi.getMyCoupon(id),
    }),
    history: (params: Omit<GetCouponsParams, 'page'>) => ({
        queryKey: ['history', params],
    // queryFn: () => CouponApi.getCouponHistories(params),
    }),
    downloadAble: (params: Omit<GetDownloadableCouponsParams, 'page'>) => ({
        queryKey: ['downloadAble', params],
    }),
});

export default couponQueries;
